import { Fragment, useEffect, useState } from "react";
import { isValidArray, resolveWesLinks } from "../../../Layout/Common/common";
import { excludeTechnicalKeywords } from "../../../constants";

export const TechnicalDetails = ({ params }) => {
  const [techData, setTechData] = useState(null);
  const [leftTechData, setLeftTechData] = useState(null);
  const [rightTechData, setRightTechData] = useState(null);
  useEffect(() => {
    if (params) {
      if (params.technicalData) {
        let techstr = params.technicalData;
        let data = JSON.parse(techstr);
        let filtereddata = data.filter(
          (item) => !excludeTechnicalKeywords.some((keyword) => item.Attr_Name.includes(keyword)),
        );
        let sorted = filtereddata
          .sort((a, b) => a.SORT_ORDER - b.SORT_ORDER)
          .map((item) => ({ ...item, Attr_Value: resolveWesLinks(item.Attr_Value) }));
        setTechData(sorted);
        //const mid = Math.ceil(sorted.length / 2);

        // setLeftTechData(sorted.slice(0, mid));
        // setRightTechData(sorted.slice(mid));
      } else {
        setTechData(null);
      }
    }
  }, [params]);

  return (
    <Fragment>
      {isValidArray(techData) && (
        <div className="prodTechDetails mt-4">
          <div className="col-lg-12">
            {/* Title */}
            <div className="proSection-title featuresListing-right">
              <h4>Technical Details</h4>
            </div>
            {/* Title */}
          </div>
          <div className="proTech-details">
            {techData.map((Item, index) => (
              <div className="proTech-details-info" key={index}>
                <div className="specs-heading">
                  <h5>{Item.DisplayName}</h5>
                </div>
                <div className="specs-details">
                  <p>
                    <span dangerouslySetInnerHTML={{ __html: Item.Attr_Value }} style={{ lineBreak: "anywhere" }} />
                  </p>
                </div>
              </div>
            ))}
          </div>

          {isValidArray(rightTechData) && (
            <div className="proTech-details">
              {rightTechData.map((Item, index) => (
                <div className="proTech-details-info" key={index}>
                  <div className="specs-heading">
                    <h5>{Item.DisplayName}</h5>
                  </div>
                  <div className="specs-details">
                    <p>
                      <span dangerouslySetInnerHTML={{ __html: Item.Attr_Value }} style={{ lineBreak: "anywhere" }} />
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};
